import { Component } from '@angular/core';

@Component({
  selector: 'hero-empty',
  standalone: true,
  imports: [],
  template: ''
})
export class HeroEmptyComponent {

}
